<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.page_heading" [ttModel]="edit.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="businessco_companyname" [ttModel]="edit.businessco_companyname" ttReadonly></tt-input>
        <tt-input-number *ngIf="edit.is_customer === '1'" ttLabel="acc_cust_no" [(ttModel)]="edit.acc_cust_no" ttTextAlign="right" ttFormatNumber ttDecimals [ttButtons]="accCustNoButtons"></tt-input-number>
        <tt-input-number *ngIf="edit.is_supplyer === '1'" ttLabel="acc_supp_no" [(ttModel)]="edit.acc_supp_no" ttTextAlign="right" ttFormatNumber ttDecimals [ttButtons]="accSuppNoButtons"></tt-input-number>
        <tt-checkbox ttLabel="access" [(ttModel)]="edit.access"></tt-checkbox>
        <tt-button-save ttText="customerbusco_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
